import React, { useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { errorToast } from "../../utils/constants";
import LoadingPopup from "./loading";
import PaymentMethods from "./paymentMethods";
import { useNavigate } from "react-router-dom";

export const StripePaymentForm = (props) => {
  const stripe = useStripe();
  const elements = useElements();

  const { setPageAction, setPageData } = props.generalDataProps;

  const [errorMessage, setErrorMessage] = useState(null);
  const [selectedCustodian, setSelectedCustodian] = useState({
    search: "",
    name: "",
    address: "",
    accountId: "",
    country: "",
    countryCode: "",
    role: "",
  });
  const [showCustodians, setShowCustodians] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (elements == null) {
      return;
    }

    const { error: submitError } = await elements.submit();
    if (submitError) {
      setErrorMessage(submitError.message);
      return;
    }

    const clientSecret = props.clientSecret;

    const { error } = await stripe.confirmPayment({
      elements,
      clientSecret,
      confirmParams: {
        return_url:
          window.location.origin +
          `/#card-payment&symbol=${props.currencySymbol}`,
      },
    });

    if (error) {
      setErrorMessage(error.message);
      errorToast("Oops something went wrong.", "Stripe Payment Failed");
      props.setPopupContentPosition("flex-end");
      props.setPopupContent(
        <PaymentMethods
          setShowPopup={props.setShowPopup}
          setPopupContent={props.setPopupContent}
          setPopupContentPosition={props.setPopupContentPosition}
          setFavouriteClicked={props.setFavouriteClicked}
          selectedCurrency={props.selectedCurrency}
          generalDataProps={props.generalDataProps}
        />,
      );
      props.setShowPopup(true);
    }
  };

  return (
    <form
      style={{ width: "100%" }}
      onSubmit={async (e) => {
        await handleSubmit(e);
      }}
    >
      <PaymentElement />
      <div
        style={{ marginTop: "15px", marginBottom: "10px" }}
        className="p-p-payment-portal-amount-info-separator"
      >
        <div className="p-p-payment-portal-line"></div>
        <p className="p-payment-portal-separator-text">Custodian</p>
        <div className="p-p-payment-portal-line"></div>
      </div>
      <div className="card-payment-fotter-content">
        <p
          style={{ width: "70%", wordWrap: "break-word" }}
          className="p-p-payment-portal-header-text"
        >
          {props.custodianDetails?.name}
          <span className="card-payment-fotter-content-label">
            {" "}
            (
            {`${props.custodianDetails?.address?.substring(
              0,
              4,
            )}...${props.custodianDetails?.address?.substring(
              props.custodianDetails?.address?.length - 5,
              props.custodianDetails?.address?.length,
            )}`}
            )
          </span>
        </p>
        <p
          onClick={() => {
            setShowCustodians(!showCustodians);
          }}
          style={{ position: "absolute", right: "15px" }}
          className="asset-info-popup-second-body-description-text-link"
        >
          Change Custodian
        </p>
      </div>
      {props.custodians?.length > 0 && showCustodians && (
        <div
          style={{
            minHeight: "200px",
            width: "100%",
            position: "relative",
            padding: "10px",
            top: "10px",
          }}
          className="offer-security-popup-body-expand-container"
        >
          {props.custodians?.map((cus, idx) => (
            <>
              {selectedCustodian.search === "" && (
                <div
                  style={{ padding: "0", gap: "0" }}
                  id={idx}
                  onClick={() => {
                    setSelectedCustodian({
                      name: cus?.name,
                      accountId: cus?.accountId,
                      address: cus?.address,
                      country: cus?.country,
                      countryCode: cus?.countryCode,
                      role: cus?.role,
                      clicked: false,
                      search: "",
                    });
                    setShowCustodians(false);
                    if (
                      cus?.address?.toLowerCase() !==
                      props.custodianDetails?.address
                    ) {
                      if (props.mobileScreen) {
                        setPageAction("card-payment");
                        setPageData([
                          {
                            name: cus?.name,
                            accountId: cus?.accountId,
                            address: cus?.address,
                            country: cus?.country,
                            countryCode: cus?.countryCode,
                            role: cus?.role,
                          },
                        ]);
                        props.setShowPopup(false);
                        navigate("/loading");
                      } else {
                        props.setPopupContent(
                          <LoadingPopup
                            setShowPopup={props.setShowPopup}
                            setPopupContent={props.setPopupContent}
                            setPopupContentPosition={
                              props.setPopupContentPosition
                            }
                            setFavouriteClicked={props.setFavouriteClicked}
                            action="card-payment"
                            isCustom={true}
                            customTextHeader="Initializing..."
                            customTextFooter={`Creating card payment gateway for ${props.selectedCurrency?.tokenName.replace(
                              "VC",
                              "",
                            )}`}
                            custodians={[
                              {
                                name: cus?.name,
                                accountId: cus?.accountId,
                                address: cus?.address,
                                country: cus?.country,
                                countryCode: cus?.countryCode,
                                role: cus?.role,
                              },
                            ]}
                            selectedCurrency={props.selectedCurrency}
                            generalDataProps={props.generalDataProps}
                            paymentType={"card"}
                            notDefaultCustodian={true}
                          />,
                        );
                        props.setPopupContentPosition("flex-end");
                        props.setShowPopup(true);
                      }
                    }
                  }}
                  className="offer-security-popup-body-first-expand-cont"
                >
                  <div className="a-f-content-search-header-main">
                    <div className="a-f-content-search-header-main-container">
                      <p className="a-f-content-search-header-text-header">
                        {cus?.name} (
                        {`${cus?.address?.substring(
                          0,
                          4,
                        )}...${cus?.address?.substring(
                          cus?.address?.length - 5,
                          cus?.address?.length,
                        )}`}
                        )
                      </p>
                    </div>
                  </div>

                  <div
                    style={{
                      height: "1px",
                      width: "100%",
                      background: "#EEEEF0",
                    }}
                  ></div>
                </div>
              )}
              {selectedCustodian.search.length > 0 &&
                cus?.name
                  .toLowerCase()
                  .includes(selectedCustodian?.search.toLowerCase()) && (
                  <div
                    onClick={() => {
                      setSelectedCustodian({
                        name: cus?.name,
                        accountId: cus?.accountId,
                        address: cus?.address,
                        country: cus?.country,
                        countryCode: cus?.countryCode,
                        role: cus?.role,
                        clicked: false,
                        search: "",
                      });
                      setShowCustodians(false);
                      if (
                        cus?.address?.toLowerCase() !==
                        props.custodianDetails?.address
                      ) {
                        props.setPopupContent(
                          <LoadingPopup
                            setShowPopup={props.setShowPopup}
                            setPopupContent={props.setPopupContent}
                            setPopupContentPosition={
                              props.setPopupContentPosition
                            }
                            setFavouriteClicked={props.setFavouriteClicked}
                            action="card-payment"
                            isCustom={true}
                            customTextHeader="Initializing..."
                            customTextFooter={`Creating card payment gateway for ${props.selectedCurrency?.tokenName.replace(
                              "VC",
                              "",
                            )}`}
                            custodians={[
                              {
                                name: cus?.name,
                                accountId: cus?.accountId,
                                address: cus?.address,
                                country: cus?.country,
                                countryCode: cus?.countryCode,
                                role: cus?.role,
                              },
                            ]}
                            selectedCurrency={props.selectedCurrency}
                            generalDataProps={props.generalDataProps}
                            paymentType={"card"}
                            notDefaultCustodian={true}
                          />,
                        );
                        props.setPopupContentPosition("flex-end");
                        props.setShowPopup(true);
                      }
                    }}
                    className="a-f-content-search-header-main"
                  >
                    <div className="a-f-content-search-header-main-container">
                      <p className="a-f-content-search-header-text-header">
                        {cus?.name} (
                        {`${cus?.address?.substring(
                          0,
                          4,
                        )}...${cus?.address?.substring(
                          cus?.address?.length - 5,
                          cus?.address?.length,
                        )}`}
                        )
                      </p>
                    </div>
                  </div>
                )}
            </>
          ))}
        </div>
      )}
      <button
        type="submit"
        onClick={async (e) => {}}
        style={{ marginBottom: "50px", marginTop: "25px", width: "100%" }}
        className="paymment-popup-content-button"
      >
        <p className="payment-popup-content-button-text">Pay</p>
      </button>
    </form>
  );
};
